<template>
  <dashboard-modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="selectedUrl ? `admin/users/${inputs.id}` : `admin/users`"
      >
        <div class="form-group row align-items-center">
          <label for="inputs_first_name" class="col-sm-3 mb-0">
            {{ $t("first_name") }}
          </label>
          <app-input
            id="inputs_first_name"
            class="col-sm-9"
            type="text"
            v-model="inputs.first_name"
            :placeholder="$t('text_type_input')"
            :required="true"
          />
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_last_name" class="col-sm-3 mb-0">
            {{ $t("last_name") }}
          </label>
          <app-input
            id="inputs_last_name"
            class="col-sm-9"
            type="text"
            v-model="inputs.last_name"
            :placeholder="$t('text_type_input')"
            :required="true"
          />
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_email" class="col-sm-3 mb-0">
            {{ $t("email") }}
          </label>
          <app-input
            id="inputs_email"
            class="col-sm-9"
            type="email"
            v-model="inputs.email"
            :placeholder="$t('email_type_input')"
            :required="true"
          />
        </div>
        <div class="form-group row align-items-center">
          <label for="inputs_status_id" class="col-sm-3 mb-0">
            {{ $t("status") }}
          </label>
          <app-input
            id="inputs_status_id"
            class="col-sm-9"
            type="select"
            v-model="inputs.status_id"
            :list="statusLists"
          />
        </div>
      </form>
    </template>
  </dashboard-modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";

export default {
  name: "AddModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      statusLists: [
        { id: "", value: "Choose One" },
        { id: 1, value: "Active" },
        { id: 2, value: "Inactive" },
        { id: 3, value: "Invite" },
      ],
      modalId: "user-add-edit-modal",
      modalTitle: this.$t("add"),
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      this.save(this.inputs);
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.inputs = response.data;
      this.preloader = false;
    },
  },
};
</script>
